import classNames from 'classnames'
import { type FC } from 'react'

export type StatusBadgeVariant = 'primary' | 'secondary' | 'tertiary'

const VARIANT_CLASS_MAP: Record<StatusBadgeVariant, string> = {
  primary: 'zocks-text-primary-dark zocks-bg-color-primary-light',
  secondary: 'zocks-text-gray-600 zocks-bg-color-gray-200',
  tertiary: 'zocks-text-gray-600 zocks-border-color-gray-900 border',
}

interface StatusBadgeProps {
  label: string
  variant: StatusBadgeVariant
}

export const StatusBadge: FC<StatusBadgeProps> = ({ label, variant }) => (
  <div
    className={classNames(
      'd-flex button-small fw-medium py-1 px-2 justify-content-center align-items-center rounded-2 zocks-border-0.5',
      VARIANT_CLASS_MAP[variant],
    )}
  >
    {label}
  </div>
)
